export default __webpack_public_path__ + "static/media/token1.faeb95cc.png";